import avatarThomas from "@/assets/reviews/thomas.png";
import avatarNicolas from "@/assets/reviews/nicolas.png";
import avatarTheo from "@/assets/reviews/theo.png";
import avatarAlexander from "@/assets/reviews/alexander.png";
import avatarJessica from "@/assets/reviews/jessica.png";
import avatarPenelope from "@/assets/reviews/penelope.png";
import avatarRenaud from "@/assets/reviews/renaud.png";

export interface GoogleReview {
  id: number;
  name: string;
  initial: string;
  initialColor: string;
  avatar?: string;
  rating: number;
  content: string;
  date: string;
}

export const GOOGLE_REVIEWS_URL = "https://share.google/1jWmq1avJAxtH7gId";
export const GOOGLE_BUSINESS_URL = GOOGLE_REVIEWS_URL;

export const googleReviews: GoogleReview[] = [
  {
    id: 1,
    name: "Thomas",
    initial: "T",
    initialColor: "bg-blue-600",
    avatar: avatarThomas,
    rating: 5,
    content: "Nous travaillons régulièrement avec eux pour de la location de villa en Provence et tout se passe toujours très bien !",
    date: "2026-03"
  },
  {
    id: 2,
    name: "Loris",
    initial: "L",
    initialColor: "bg-purple-600",
    rating: 5,
    content: "Professionnalisme, rigueur et disponibilité. Trois mots qui résument parfaitement mon expérience avec la Conciergerie Cabassol. Je recommande vivement.",
    date: "2026-03"
  },
  {
    id: 3,
    name: "Manon",
    initial: "M",
    initialColor: "bg-rose-600",
    rating: 5,
    content: "Nous venons de Genève et c'était notre première fois à Aix-en-Provence. Le logement était absolument charmant, très propre et parfaitement situé pour découvrir la ville à pied. Eliott nous a accueillis avec beaucoup de gentillesse et nous a recommandé des adresses que nous n'aurions jamais trouvées seuls — un petit marché, une terrasse avec vue, un domaine viticole magnifique. Tout était simple, bien organisé, sans aucune mauvaise surprise. On se sentait presque comme chez nous, avec le soleil en plus ! Merci encore pour ce beau séjour, nous reviendrons avec plaisir.",
    date: "2026-03"
  },
  {
    id: 4,
    name: "Nicolas",
    initial: "N",
    initialColor: "bg-emerald-600",
    avatar: avatarNicolas,
    rating: 5,
    content: "Un service de conciergerie vraiment irréprochable ! L'équipe est à la fois professionnelle, réactive et très à l'écoute, ce qui permet de tout gérer en toute sérénité. La communication est fluide et agréable, et chaque détail est pris en compte avec soin. Une vraie tranquillité d'esprit au quotidien, je recommande sans hésiter !",
    date: "2026-03"
  },
  {
    id: 5,
    name: "Jules",
    initial: "J",
    initialColor: "bg-violet-600",
    rating: 5,
    content: "Sérieux, réactifs et à l'écoute. Nos voyageurs repartent toujours ravis et la gestion est sans stress pour nous. Je recommande les yeux fermés.",
    date: "2026-03"
  },
  {
    id: 6,
    name: "Theo",
    initial: "T",
    initialColor: "bg-lime-600",
    avatar: avatarTheo,
    rating: 5,
    content: "Conciergerie au top ! sérieuse et efficace. Équipe réactive et service de qualité. Je recommande !",
    date: "2026-03"
  },
  {
    id: 7,
    name: "Olga",
    initial: "O",
    initialColor: "bg-fuchsia-600",
    rating: 5,
    content: "Nous avons passé quatre jours merveilleux en Provence avec nos enfants ! Tout était parfaitement organisé : on nous a accueillis à l'aéroport, la villa que nous avions choisie était calme et spacieuse, et les enfants ont adoré ! Les restaurants français recommandés étaient excellents ! Mon mari a adoré ! Je recommande vivement !",
    date: "2026-03"
  },
  {
    id: 8,
    name: "Oksana",
    initial: "O",
    initialColor: "bg-amber-600",
    rating: 5,
    content: "Un séjour dans le Sud comme on les aime ! Tout était clair et prêt à l'arrivée, on a donc pu profiter directement sans se poser de questions. Le contact a été chaleureux, c'était vraiment agréable. Je repars avec un très beau souvenir !",
    date: "2026-03"
  },
  {
    id: 9,
    name: "Gaël",
    initial: "G",
    initialColor: "bg-teal-600",
    rating: 5,
    content: "Nous avons utilisé les services de la Conciergerie Cabassol pour notre location pendant les vacances de la Toussaint et avons particulièrement apprécié le conseil pour nous trouver la Maison parfaite et les petites attentions lors de la visite et même après. Merci Eliott !",
    date: "2026-02"
  },
  {
    id: 10,
    name: "Alexander",
    initial: "A",
    initialColor: "bg-indigo-600",
    avatar: avatarAlexander,
    rating: 5,
    content: "I've referred a number of clients to Cabassol Concierge Service and the feedback has always been excellent. They're consistently professional, quick to respond and handle requests seamlessly, no matter how last minute or complex. They always seem to have the right calibre of contacts available at any point, which makes it very easy to trust them with important clients. They also represent some stunning properties in the South of France, which have been very well received by my clients. Because of this, I would have absolutely no hesitation sending any of my clients their way again. A very dependable and well run concierge service.",
    date: "2026-02"
  },
  {
    id: 11,
    name: "Alexis",
    initial: "A",
    initialColor: "bg-orange-600",
    rating: 5,
    content: "Très bonne expérience dans le sud de la France. Des vacances paradisiaques avec mes enfants, un service réactif et très agréable, merci Eliott. Nous reviendrons avec plaisir pour d'autres échappées Provençales.",
    date: "2026-02"
  },
  {
    id: 12,
    name: "Jessica",
    initial: "J",
    initialColor: "bg-pink-600",
    avatar: avatarJessica,
    rating: 5,
    content: "Conciergerie disponible, très efficace. Nous avons été très bien conseillés sur la location de notre bien. Des conseils pratiques, pragmatiques avec un vrai suivi de proximité et au final une optimisation des locations sans soucis. Des tarifs raisonnables pour un très bon niveau de service. Je recommande.",
    date: "2026-02"
  },
  {
    id: 13,
    name: "Anastacia",
    initial: "A",
    initialColor: "bg-cyan-600",
    rating: 5,
    content: "J'ai confié la gestion de mon bien à cette conciergerie et j'en suis vraiment ravie. Le service est sérieux, bien organisé et toujours attentif à mes besoins. Les échanges sont simples et rassurants, ce qui est très appréciable. Je suis très contente d'avoir fait appel à leurs services !",
    date: "2026-02"
  },
  {
    id: 14,
    name: "Rafael Galvis",
    initial: "R",
    initialColor: "bg-orange-600",
    rating: 5,
    content: "J'ai loué un appartement et ce fut une expérience très agréable et paisible. Je me suis sentie à l'aise et bien prise en charge. Merci !",
    date: "2026-04"
  },
  {
    id: 15,
    name: "Alejandra Nohelia",
    initial: "A",
    initialColor: "bg-sky-600",
    rating: 5,
    content: "Le service était excellent. La maison regorgeait de petites attentions à notre arrivée et était en parfait état. L'accueil de la conciergerie Cabassol était chaleureux et amical, et ils étaient toujours disponibles pour répondre à nos besoins. Un grand merci, et nous reviendrons sans hésiter !",
    date: "2026-04"
  },
  {
    id: 16,
    name: "J K",
    initial: "J",
    initialColor: "bg-red-600",
    rating: 5,
    content: "Nous avons passé un superbe séjour en famille, tout était comme on l'espérait. Je recommande vivement !",
    date: "2026-04"
  },
  {
    id: 17,
    name: "KB",
    initial: "K",
    initialColor: "bg-yellow-600",
    rating: 5,
    content: "Propriétaire depuis peu sur Aix, j'avais besoin d'être accompagné pour la mise en location saisonnière de ma maison. Eliott a tout pris en main avec une efficacité remarquable : photos, annonces, gestion des voyageurs, ménage, linge… Je recommande sans hésiter.",
    date: "2026-04"
  },
  {
    id: 18,
    name: "Gabriel Btl",
    initial: "G",
    initialColor: "bg-blue-700",
    rating: 5,
    content: "Une conciergerie qui fait vraiment la différence. Depuis que j'ai confié mon appartement à la Conciergerie Cabassol tout a été géré de manière efficace et professionnelle et j'ai pu me libérer énormément de temps libre. Eliot est un vrai partenaire de confiance depuis notre rencontre.",
    date: "2026-05"
  },
  {
    id: 19,
    name: "Jonah Bouhassoun",
    initial: "J",
    initialColor: "bg-green-700",
    rating: 5,
    content: "Logement impeccable, accueil soigné, recommandations locales au top. Conciergerie réactive et aux petits soins. Un séjour en Provence comme on les aime ! On recommande !",
    date: "2026-06"
  }
];
